//
export default class AccAccountingSeatConceptFields {

  /**
   * 
   */
  static toCreate() {
    return [
      {
        name: 'code',
        type: 'text-field',
        flex: {
          xs12: true,
        },
        props: {
          label: 'Código',
        },
      },
      {
        name: 'concept',
        type: 'textarea',
        flex: {
          xs12: true,
        },
        props: {
          label: 'Concepto',
        },
      },
    ]
  } 

  /**
   * 
   */
  static toUpdate() {
    return [
      {
        name: 'code',
        type: 'text-field',
        flex: {
          xs12: true,
        },
        props: {
          label: 'Código',
        },
      },
      {
        name: 'concept',
        type: 'textarea',
        flex: {
          xs12: true,
        },
        props: {
          label: 'Concepto',
        },
      },
    ]
  } 
}